import { render } from "./TargetTextOne.vue?vue&type=template&id=02c6d6e7&scoped=true"
import script from "./TargetTextOne.vue?vue&type=script&lang=js"
export * from "./TargetTextOne.vue?vue&type=script&lang=js"

import "./TargetTextOne.vue?vue&type=style&index=0&id=02c6d6e7&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02c6d6e7"]])

export default __exports__